module.exports = __webpack_public_path__ + "src/assets/svgs/landingV2/business/htj-cat-2.svg";